import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'

export default {
  // get sales customer list
  getSalesCustomerList: async ({ commit }) => {
    // set loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.get('/reports/sales-customer-list')

      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // set customer
      commit('SET_STATE', {
        action: 'customer_list',
        data: res.data.customer
      })

      return {
        data: res.data.customer
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get search result (sales return report)
  getSalesReturnReports: async ({ commit }, payload) => {
    // set loading
    commit('SET_STATE', {
      action: 'records_loading',
      data: true
    })

    try {
      const res = await axios.get('/reports/sales-return-report', {
        params: payload
      })

      // set loading
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      // set data
      commit('SET_STATE', {
        action: 'reports_data',
        data: res.data.data
      })

      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })

      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })

      return {
        data: res.data
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get expense result (expense report result)
  getExpenseReport: async ({ commit }, payload) => {
    // set loading
    commit('SET_STATE', {
      action: 'records_loading',
      data: true
    })

    const { limit, page, order, search, categoryId, fromDate, toDate } = payload

    try {
      const res = await axios.get('/reports/expense-report-list', {
        params: {
          limit,
          page,
          search,
          order,
          categoryId,
          fromDate,
          toDate
        }
      })

      // set loading
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      // set data
      commit('SET_STATE', {
        action: 'reports_data',
        data: res.data.data
      })

      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })

      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })

      return {
        data: res.data
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get expense result (expense report result)
  geProductHistoricalReport: async ({ commit }, payload) => {
    // set loading
    commit('SET_STATE', {
      action: 'records_loading',
      data: true
    })

    try {
      const res = await axios.get('/reports/product-history-report', {
        params: payload
      })

      // set loading
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      // set data
      commit('SET_STATE', {
        action: 'reports_data',
        data: res.data.data
      })

      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })

      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })

      return {
        data: res.data
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get tax report
  getTaxReport: async ({ commit }, payload) => {
    // set loading
    commit('SET_STATE', {
      action: 'records_loading',
      data: true
    })

    const { limit, page, order, search, taxType, fromDate, toDate } = payload

    try {
      const res = await axios.get('/reports/tax-report-list', {
        params: {
          limit,
          page,
          search,
          order,
          taxType,
          fromDate,
          toDate
        }
      })

      // set loading
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      // set data
      commit('SET_STATE', {
        action: 'reports_data',
        data: res.data.data
      })

      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })

      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })

      return {
        data: res.data
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get stock report
  getStockReport: async ({ commit }, payload) => {
    // set loading
    commit('SET_STATE', {
      action: 'records_loading',
      data: true
    })

    const { limit, page, order, search } = payload

    try {
      const res = await axios.get('/reports/stock-report', {
        params: {
          limit,
          page,
          search,
          order
        }
      })

      // set loading
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      // set data
      commit('SET_STATE', {
        action: 'reports_data',
        data: res.data.data
      })

      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })

      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })

      return {
        data: res.data
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get item sales report
  getItemSalesReport: async ({ commit }, payload) => {
    // set loading
    commit('SET_STATE', {
      action: 'records_loading',
      data: true
    })

    try {
      const res = await axios.get('/reports/item-sales-report', {
        params: payload
      })

      // set loading
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      // set data
      commit('SET_STATE', {
        action: 'reports_data',
        data: res.data.sales
      })
      return {
        data: res.data
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get sales user list
  getSalesUserList: async ({ commit }) => {
    // set loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.get('/reports/groups-user-list')

      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // set data
      commit('SET_STATE', {
        action: 'sales_user_list',
        data: res.data.users
      })

      return {
        data: res.data
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get sales payment report
  getSalesPaymentReport: async ({ commit }, payload) => {
    try {
      const res = await axios.get('/reports/sales-payment-list', {
        params: payload
      })

      // set data
      commit('SET_STATE', {
        action: 'reports_data',
        data: res.data.data
      })

      return {
        data: res.data
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get sales report
  getSalesReport: async ({ commit }, payload) => {
    // set loading
    commit('SET_STATE', {
      action: 'records_loading',
      data: true
    })

    try {
      const res = await axios.get('/reports/sales-report', {
        params: {
          ...payload
        }
      })

      // set loading
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      // set data
      commit('SET_STATE', {
        action: 'reports_data',
        data: res.data
      })

      return {
        data: res.data
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get item profit report
  getItemProfitReport: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'records_loading',
      data: true
    })

    const { limit, page, order, search, fromDate, toDate } = payload

    try {
      const res = await axios.get('/reports/item-wise-profit', {
        params: {
          limit,
          page,
          search,
          order,
          fromDate,
          toDate
        }
      })

      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'reports_data',
        data: res.data.data
      })

      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })

      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })

      return {
        data: res.data
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      const { message } = getMessageFromError(err)

      return Promise.reject({
        message
      })
    }
  },

  // get invoice profit report
  getInvoiceProfitReport: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'records_loading',
      data: true
    })

    const { limit, page, order, search, fromDate, toDate } = payload

    try {
      const res = await axios.get('/reports/invoice-wise-profit', {
        params: {
          limit,
          page,
          search,
          order,
          fromDate,
          toDate
        }
      })

      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'reports_data',
        data: res.data.data
      })

      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })

      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })

      return {
        data: res.data
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      const { message } = getMessageFromError(err)

      return Promise.reject({
        message
      })
    }
  },

  // get cultivator report
  getCultivatorReport: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'records_loading',
      data: true
    })

    const { month, year } = payload

    try {
      const res = await axios.get('/reports/cultivator-report', {
        params: {
          year,
          month
        }
      })

      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'reports_data',
        data: res.data
      })

      return {
        data: res.data
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      const { message } = getMessageFromError(err)

      return Promise.reject({
        message
      })
    }
  },

  // get processor report
  getProcessorReport: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'records_loading',
      data: true
    })

    const { month, year } = payload

    try {
      const res = await axios.get('/reports/processor-report', {
        params: {
          year,
          month
        }
      })

      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'reports_data',
        data: res.data
      })

      return {
        data: res.data
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      const { message } = getMessageFromError(err)

      return Promise.reject({
        message
      })
    }
  },

  // get dispensary report
  getDispensaryReport: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'records_loading',
      data: true
    })

    const { month, year } = payload

    try {
      const res = await axios.get('/reports/retailer-report', {
        params: {
          year,
          month
        }
      })

      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'reports_data',
        data: res.data
      })

      return {
        data: res.data
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'records_loading',
        data: false
      })

      const { message } = getMessageFromError(err)

      return Promise.reject({
        message
      })
    }
  }
}
